/**
 * Кадр разметки для слоя поверх рабочего стола (настольное приложение).
 *
 * Слой живёт в ОТДЕЛЬНОМ окне приложения: своего подключения к звонку у него
 * нет и быть не должно (вторая сессия в комнате — лишний участник и лишний
 * трафик). Поэтому основное окно раз в 50 мс отправляет ему готовую картинку в
 * долях кадра, а слой только рисует.
 *
 * Имена и цвета тоже приходят готовыми: справочник участников живёт в основном
 * окне, и тащить его во второе — значит дублировать половину клиента.
 */

/** Событие Tauri, которым основное окно кормит слой. */
export const OVERLAY_EVENT = "annotate:frame";

/** Ответ слоя о приёме кадра — им пользуется самопроверка приложения. */
export const OVERLAY_ACK_EVENT = "annotate:frame-ack";

/** Метка окна-слоя в приложении (совпадает с overlay.rs). */
export const OVERLAY_WINDOW = "overlay";

export interface OverlayCursor {
  id: string;
  name: string;
  color: string;
  /** Доли кадра, 0…1. */
  x: number;
  y: number;
  laser: boolean;
}

export interface OverlayStroke {
  /** Плоский список [x0, y0, x1, y1, …] в долях кадра. */
  points: number[];
  color: string;
  /** Толщина в долях высоты кадра. */
  width: number;
  /** SHAPE_* из protocol. */
  shape: number;
  /** 0…1 — угасание по ttl. */
  alpha: number;
}

export interface OverlayFrame {
  cursors: OverlayCursor[];
  strokes: OverlayStroke[];
}

/** Глобальный Tauri API — он есть только в настольном приложении. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TauriGlobal = any;

export function tauri(): TauriGlobal | undefined {
  if (typeof window === "undefined") return undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any).__TAURI__;
}

/** Приложение это или браузер. */
export function isDesktopApp(): boolean {
  return !!tauri();
}
